import loaderIcon from "@/assets/icons/loader-icon.svg";
import loaderIconWhite from "@/assets/icons/loader-icon-white.svg";
import { useTheme } from "@/providers/theme-provider.tsx";

/**
 * The oneai mark (no background) for the active theme: white in dark mode to
 * match the brand logo, purple in light mode, where white would vanish.
 */
export function useOneaiMarkSrc(): string {
	const { resolvedTheme } = useTheme();
	return resolvedTheme === "dark" ? loaderIconWhite : loaderIcon;
}
